import { Icon } from '@risksmart-app/atomic-ui';

import { objectToolbarActionTestId } from '../testIds';
import type { ToolbarAction } from '../types';
import type { RevealMode } from './RevealButton';
import { RevealButton } from './RevealButton';

interface Props {
  action: ToolbarAction;
  /** How the title is revealed on hover. See {@link RevealMode}. */
  reveal: RevealMode;
}

/**
 * A primary (inline) toolbar action: an icon button whose title is revealed on
 * hover via the shared {@link RevealButton}. Thin descriptor→button adaptor.
 */
export const PrimaryActionButton = ({ action, reveal }: Props) => (
  <RevealButton
    label={action.label}
    reveal={reveal}
    disabled={action.disabled}
    onClick={action.onClick}
    testId={objectToolbarActionTestId(action.id)}
  >
    {action.iconName ? <Icon name={action.iconName} size={'lg'} /> : null}
  </RevealButton>
);
